import React, { FC } from 'react'
import { DashboardErrorBox } from './styled'

interface DashboardErrorProps {
	children: React.ReactNode
}

const DashboardError: FC<DashboardErrorProps> = ({
	children,
}: DashboardErrorProps) => {
	return <DashboardErrorBox>{children}</DashboardErrorBox>
}

export default DashboardError
